import React, { createContext, useCallback, useContext, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { get } from "../helpers/api_helper"

const StoreContext = createContext({
  store: null,
  loading: false,
  refreshStore: async () => null,
})

export const StoreProvider = ({ children }) => {
  const [store, setStore] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("storeDetail")) || null
    } catch {
      return null
    }
  })
  const [loading, setLoading] = useState(Boolean(localStorage.getItem("authUser")))

  const refreshStore = useCallback(async () => {
    if (!localStorage.getItem("authUser")) {
      setStore(null)
      setLoading(false)
      return null
    }

    setLoading(true)
    try {
      const response = await get("store/mine")
      if (response.status === 200) {
        setStore(response.data)
        localStorage.setItem("storeDetail", JSON.stringify(response.data))
        return response.data
      }
      setStore(null)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    refreshStore()
  }, [refreshStore])

  return (
    <StoreContext.Provider value={{ store, loading, refreshStore }}>
      {children}
    </StoreContext.Provider>
  )
}

StoreProvider.propTypes = {
  children: PropTypes.node,
}

export const useStore = () => useContext(StoreContext)
